import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { cargarPlanes, useDatosAlta, tieneSofi } from "../lib/planes";
import { COPY_PA3 as T } from "../lib/pruebaGratis";

export default function PruebaGratis() {
  const alta = useDatosAlta();
  const abierta = alta.datos?.prueba_clinicas_autoservicio === true;
  const [planes, setPlanes] = useState([]);
  const [form, setForm] = useState({ clinic_name: "", name: "", email: "", phone: "", plan_slug: "" });
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  useEffect(() => {
    if (!abierta) return;
    let viva = true;
    cargarPlanes().then(lista => viva && setPlanes(lista.filter(p =>
      p.slug in T.planes && tieneSofi(p) && !p.requires_quote)))
      .catch(() => viva && setError(T.error));
    return () => { viva = false; };
  }, [abierta]);
  if (alta.estado === "cargando") return null;
  // Misma navegación que una ruta inexistente en esta SPA; API: 404 real antes de sesión.
  if (alta.estado === "ok" && !abierta) return <Navigate to="/" replace />;
  async function enviar(e) {
    e.preventDefault();
    if (enviando) return;
    if (!planes.some(p => p.slug === form.plan_slug)) { setError(T.eligePlan); return; }
    setEnviando(true); setError("");
    try {
      await api.post("/prueba-gratis", form);
      setEnviado(true);
    } catch (err) {
      setError(err.response?.status === 429 ? T.limite : err.response?.status === 422 ? T.datos : T.error);
    } finally { setEnviando(false); }
  }
  return <main className="min-h-screen bg-slate-50 px-5 py-12">
    <section className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-7 shadow-sm">
      <h1 className="text-3xl font-bold text-slate-900">{T.titulo}</h1>
      <p className="my-5 text-slate-600">{T.bajada}</p>
      {enviado ? <p role="status">{T.enviado}</p> : alta.estado === "error" ? <p role="alert">{T.error}</p> :
        <form onSubmit={enviar} className="space-y-4">
          {[["clinic_name", T.clinica, "text"], ["name", T.nombre, "text"], ["email", T.correo, "email"], ["phone", T.telefono, "tel"]].map(([key, label, type]) =>
            <label key={key} className="block text-sm font-medium text-slate-700">{label}
              <input name={key} type={type} required maxLength={key === "phone" ? 10 : 200}
                pattern={key === "phone" ? "[0-9]{10}" : undefined} className="input mt-1 w-full"
                value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} />
            </label>)}
          <label className="block text-sm font-medium text-slate-700">{T.plan}
            <select required className="input mt-1 w-full" value={form.plan_slug} onChange={e => setForm({ ...form, plan_slug: e.target.value })}>
              <option value="">{T.eligePlan}</option>
              {planes.map(p => <option key={p.slug} value={p.slug}>{T.planes[p.slug]}</option>)}
            </select>
          </label>
          {error && <p role="alert">{error}</p>}
          <button disabled={enviando || !planes.length} className="rounded-lg bg-blue-600 px-5 py-3 text-white disabled:opacity-50">{T.enviar}</button>
        </form>}
    </section>
  </main>;
}
